module.exports = __webpack_public_path__ + "img/capitol_hill_library_9615.4b16bf58.jpg";